import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Utils from './utils'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

function resize () {
  var whdef = 12 / 1920
  // var wW = Math.max(window.innerWidth, 1200)
  // if (window.innerWidth < 720) {
  //   wW = window.innerWidth
  // }
  var wW = window.innerWidth
  var rem = wW * whdef
  document.querySelector("html").style.fontSize = `${rem}px`
}


function change() {
  if (Utils.isPc()) {
    resize()
  } else {
    Utils.resize(375)
  }
}

change()

window.addEventListener('resize', resize)